import { GeneralStyle } from '@website-builder/model/style/general-style';

export class CountdownStyle extends GeneralStyle {
  numberFont = 'tb-font-secondary';
  labelFont = 'tb-font-primary';
  numberColor = 'uk-color-primary';
  labelColor = 'uk-color-secondary';
  decorationColor = 'tb-countdown-decoration-primary';
  countdownSize = 'countdown-default-size';
  countdownFontStyle = '';

  static normalize(styles: Partial<CountdownStyle>): CountdownStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const pureStyles = new CountdownStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.numberFont = styles.numberFont ?? pureStyles.numberFont;
    pureStyles.labelFont = styles.labelFont ?? pureStyles.labelFont;
    pureStyles.numberColor = styles.numberColor ?? pureStyles.numberColor;
    pureStyles.labelColor = styles.labelColor ?? pureStyles.labelColor;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.countdownSize = styles.countdownSize ?? pureStyles.countdownSize;
    pureStyles.countdownFontStyle = styles.countdownFontStyle ?? pureStyles.countdownFontStyle;

    return pureStyles;
  }
}
